import { IndustryProperties } from '@/infrastructure/network/Monitaro/schema/models'

export interface IIndustryProps {
  id?: string
  name: string | null
  order: number | null
  chargeable: string | null
  properties: IndustryProperties | null
  createdAt: string | null
  updatedAt: string | null
}

export default class IndustryEntity {
  private _props: IIndustryProps

  constructor(props?: IIndustryProps | null) {
    this._props = EmptyIndustryPropsFactory(props)
  }

  get props(): IIndustryProps {
    return this._props
  }

  get clone(): IIndustryProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get order(): number | null {
    return this._props.order
  }

  get chargeable(): string | null {
    return this._props.chargeable
  }

  get properties(): IndustryProperties | null | undefined {
    return this._props.properties
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyIndustryPropsFactory = (props?: Partial<IIndustryProps> | null): IIndustryProps => ({
  name: null,
  order: null,
  chargeable: null,
  properties: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
